/**
 * Shared AI prompt placeholders — used by Prompt Masters and future AI popup.
 * Detect dynamic fields with: PLACEHOLDER_REGEX.exec(promptContent)
 */
export const PLACEHOLDER_REGEX = /{{(.*?)}}/g;

export const SUPPORTED_PROMPT_PLACEHOLDERS = [
  "{{Title}}",
  "{{ShortDescription}}",
  "{{FullDescription}}",
  "{{MetaTitle}}",
  "{{MetaKeywords}}",
  "{{MetaDescription}}",
];

export const extractPlaceholdersFromPrompt = (promptContent) => {
  if (!promptContent || typeof promptContent !== "string") return [];
  const matches = [...promptContent.matchAll(PLACEHOLDER_REGEX)];
  return [...new Set(matches.map((m) => m[0]))];
};
